import DeviceUpload from "./DeviceUpload";

export default DeviceUpload;
